import { _ } from '@zto/zpage'

import { commonOptions } from '@/config/options'

import { addEditDialog, logDialog, operateDialog } from './_dialogs'
import { DialogType, TdlDeviceStatus, TdlDeviceType } from '@/config'
import { getCommonOptionLabel } from '@/utils'
import sn from '../sn'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/device/device-list/pageList',
        apiParams: {
          onlyBoundSite: false
        }
      },
      add: {
        api: '/sys/admin/device/device-list/add',
        dialog: addEditDialog(DialogType.ADD)
      },
      edit: {
        api: '/sys/admin/device/device-list/update',
        dialog: addEditDialog(DialogType.EDIT)
      },
      unbind: {
        api: '/sys/admin/device/device-list/unbindSite',
        apiParams: {
          snCode: '${data.row.snCode}',
          siteCode: '${data.row.siteCode}'
        },
        message: '确定要将设备【${data.row.snCode}】从站点【${data.row.siteName}】解绑吗？解绑后设备将无所属站点。'
      },
      log: {
        dialog: logDialog()
      },
      detail: {
        label: '详情',
        link: {
          title: '设备详情（${data.row.snCode}）',
          name: 'tuda.tdl.device.detail',
          path: '/tdl/device/detail',
          query: {
            snCode: '${data.row.snCode}'
          }
        }
      },
      recall: {
        dialog: operateDialog('RECALL')
      },
      reboot: {
        dialog: operateDialog('REBOOT')
      },
      stop: {
        dialog: operateDialog('STOP')
      },
      export: {
        fileName: '设备列表',
        api: {
          url: '/sys/admin/device/device-list/pageList/cursor',
          responseTransform: (res: any) => {
            res.list = (res.list || []).map((it: any) => {
              it.deviceType = getCommonOptionLabel(commonOptions.tdlDeviceType, it.deviceType)
              it.deviceStatus = getCommonOptionLabel(commonOptions.tdlDeviceStatus, it.deviceStatus)
              it.onlineStatus = getCommonOptionLabel(commonOptions.tdlOnlineStatus, it.onlineStatus)
              return { ...it }
            })

            return res
          }
        },
        apiParams: { pageSize: 1000 }
      }
    },
    search: {
      items: [
        {
          type: 'select',
          prop: 'deviceType',
          label: '设备类型',
          default: TdlDeviceType.VEHICLE,
          disabled: true,
          options: 'tdlDeviceType'
        },
        { type: 'input', prop: 'snCode', label: '设备SN' },
        { type: 'input', prop: 'modelName', label: '型号名称' },
        {
          type: 'fuzzy-select',
          label: '所属站点',
          prop: 'siteCode',
          api: '/sys/admin/site/enablePage',
          keywordProp: 'keyWord',
          optionValueProp: 'siteCode',
          optionLabelProp: 'siteName',
          triggerFocus: true
        },
        { type: 'input', prop: 'manufacturerName', label: '供货厂商' },
        { type: 'select', prop: 'deviceStatus', label: '设备状态', options: 'tdlDeviceStatus' }
      ]
    },
    toolbar: {
      items: [
        { action: 'add', label: '新增设备' },
        { action: 'export', label: '导出' }
      ]
    },
    table: {
      innerAttrs: { rowKey: 'snCode' },
      operation: {
        width: 120,
        items: [
          { action: 'detail' },
          { action: 'edit' },
          { action: 'log', label: '日志' },
          {
            action: 'recall',
            label: '召回',
            visibleOn: `this.data.row.deviceStatus !== '${TdlDeviceStatus.UNDER_RECALL}'`
          },
          {
            action: 'unbind',
            label: '解绑',
            visibleOn: `!!this.data.row.siteCode`
          }
          // { action: 'reboot', label: '重启' },
          // { action: 'stop', label: '停止', visibleOn: `this.data.row.deviceStatus !== '${TdlDeviceStatus.STOPPED}'` }
        ]
      },
      columns: [
        { label: '设备类型', prop: 'deviceType', formatter: { name: 'enumStr', options: 'tdlDeviceType' }, width: 120 },
        { label: '设备SN', prop: 'snCode', width: 200 },
        { label: '设备名称', prop: 'name', width: 200 },
        { label: '所属整车', prop: 'parentSn', width: 200 },
        { label: '型号', prop: 'modelName', width: 180 },
        { label: '供货厂商', prop: 'manufacturerName', width: 150 },
        { label: '所属站点', prop: 'siteName', width: 150 },
        { label: '状态', prop: 'deviceStatus', width: 150, formatter: { name: 'enumStr', options: 'tdlDeviceStatus' } },
        {
          label: '电量',
          prop: 'power',
          width: 150,
          formatter: (data: any) => (_.isNumber(data.power) ? data.power + '%' : '--')
        },
        {
          label: '网络状态',
          prop: 'onlineStatus',
          width: 80,
          formatter: { name: 'enumStr', options: 'tdlOnlineStatus' }
        },
        { label: '最后上报', prop: 'finalReportingTime', width: 150 }
      ]
    }
  }
}
